import i18n from "../../../i18n";

export const HASH_CARD_STATUS:any =[
    {
        label: i18n.t('FinanceStatements.StatusTypes.ACTIVE'),
        value: '1',
      },
      {
        label: i18n.t('FinanceStatements.StatusTypes.INACTIVE'),
        value: '0',
      }
    ];

export const HASH_CARD_ALLOWED_GROUPS = ["RISK", "SUPPORT", "SETTLEMENT"];

